var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHfxCloudAssessment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28709 0.502825C6.51201 -0.167608 7.48888 -0.167608 7.71305 0.502825L8.85186 3.90522C8.90087 4.05116 8.99614 4.17833 9.12406 4.26854C9.25198 4.35875 9.40599 4.40738 9.56409 4.4075H13.2489C13.9754 4.4075 14.2768 5.31014 13.6898 5.72507L10.7089 7.82736C10.5809 7.91774 10.4856 8.04516 10.4367 8.19135C10.3878 8.33755 10.3878 8.49502 10.4368 8.6412L11.5748 12.0436C11.7997 12.7147 11.0088 13.2724 10.4218 12.8574L7.4409 10.7551C7.31278 10.6647 7.15846 10.616 7.00007 10.616C6.84168 10.616 6.68736 10.6647 6.55924 10.7551L3.57838 12.8574C2.99136 13.2724 2.20041 12.714 2.42533 12.0436L3.56339 8.6412C3.61233 8.49502 3.61236 8.33755 3.56347 8.19135C3.51458 8.04516 3.41929 7.91774 3.29124 7.82736L0.310388 5.72507C-0.277386 5.31014 0.0254974 4.4075 0.751219 4.4075H4.4353C4.59353 4.40754 4.74771 4.35897 4.87578 4.26875C5.00385 4.17853 5.09923 4.05128 5.14828 3.90522L6.28709 0.502825V0.502825Z",
    fill: "#FFDD05"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHfxCloudAssessment);
export default __webpack_public_path__ + "static/media/HFXCloudAssessment.01b9f1bf100997971426b4c1dc55e5e2.svg";
export { ForwardRef as ReactComponent };